export const TEST_ID = 'sparkline';

export const SPARKLINE_WIDTH = 300;

export const SPARKLINE_HEIGHT = 28;

export const SPARKLINE_STROKE_WIDTH = '1.2';

export const MIN_PEAK = 1;
